module.exports = __webpack_public_path__ + "3f16e137/img/comment-question-icon.7dd26e04.svg";